import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import { IconButton as Button } from './styled';

export const IconButton = ({
  icon: Icon, size, filled, color, ...rest
}) => {
  const theme = useTheme();
  return (
    <Button {...rest}>
      <Icon
        color={color || theme.colors.text02}
        filled={filled}
        style={{ width: size, height: size }}
      />
    </Button>
  );
};

IconButton.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  size: PropTypes.string,
  filled: PropTypes.bool,
  color: PropTypes.string
};

IconButton.defaultProps = {
  size: '24px',
  filled: false,
  color: ''
};

export default IconButton;
